'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCompact$002dPlan from "./presto.types$-Compact-Plan.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactPlan$() {
}
export { $c_Lpresto_types$CompactPlan$ as $c_Lpresto_types$CompactPlan$ };
$p = $c_Lpresto_types$CompactPlan$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactPlan$;
/** @constructor */
function $h_Lpresto_types$CompactPlan$() {
}
export { $h_Lpresto_types$CompactPlan$ as $h_Lpresto_types$CompactPlan$ };
$h_Lpresto_types$CompactPlan$.prototype = $p;
$p.l = (function() {
  return "CompactPlan";
});
$p.acV = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCompact$002dPlan.$c_Lpresto_types$CompactPlan(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$CompactPlan$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactPlan$, "presto.types$CompactPlan$", ({
  Z6: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CompactPlan$ as $d_Lpresto_types$CompactPlan$ };
var $n_Lpresto_types$CompactPlan$;
function $m_Lpresto_types$CompactPlan$() {
  if ((!$n_Lpresto_types$CompactPlan$)) {
    $n_Lpresto_types$CompactPlan$ = new $c_Lpresto_types$CompactPlan$();
  }
  return $n_Lpresto_types$CompactPlan$;
}
export { $m_Lpresto_types$CompactPlan$ as $m_Lpresto_types$CompactPlan$ };
//# sourceMappingURL=presto.types$-Compact-Plan$.js.map
